module.exports = require('./helpers/bundle-url').getBundleURL('7JE76') + "2monkey.64010eb4.glb" + "?" + Date.now();